import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.5
const Tiles = [
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-1.jpg",
    path: "/assets/images/gallery/2-1.jpg",
    position: {
      x: 0 + Start,
      y: -0.1
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE LIVING SPACE",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-2.jpg",
    path: "/assets/images/gallery/2-2.jpg",
    position: {
      x: 2.6 + Start,
      y: 0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.16 }
    },
    caption: {
      label: "KITCHEN-LIVING SPACE - East",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-3.jpg",
    path: "/assets/images/gallery/2-3.jpg",
    position: {
      x: 5.1 + Start,
      y: -0.1
    },
    title: {
      label: "",
      position: { x: 0, y: 1.16 }
    },
    caption: {
      label: "KITCHEN-LIVING SPACE - West",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-4.jpg",
    path: "/assets/images/gallery/2-4.jpg",
    position: {
      x: 7.5 + Start,
      y: 0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "MASTER BEDROOM",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-5.jpg",
    path: "/assets/images/gallery/2-5.jpg",
    position: {
      x: 10.1 + Start,
      y: -0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "SECONDARY BEDROOM",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-6.jpg",
    path: "/assets/images/gallery/2-6.jpg",
    position: {
      x: 12.3 + Start,
      y: 0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "MAIN BATHROOM",
      position: { x: 0, y: 0 }
    }
  },
  {
    thumbnail_path: "/assets/images/gallery/placeholder/2-7.jpg",
    path: "/assets/images/gallery/2-7.jpg",
    position: {
      x: 13.7 + Start,
      y: -0.2
    },
    title: {
      label: "",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "ENSUITE BATHROOM",
      position: { x: 0, y: 0 }
    }
  }
]

const TileData = {
  icon: TitleIcon,
  top: "4vw",
  left: "6vw",
  bottom: "auto",
  right: "auto",
  width: "33vw"
}

const ResidencesGallery = () => <Gallery3D title={TileData} tiles={Tiles} length={15.1} />

export default ResidencesGallery
